var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnydayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 387,
    viewBox: "0 0 488 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.846 387H140.378L183.313 265.349C143.301 234.128 85.4871 236.989 48.7377 273.933L0 224.939C56.1381 168.505 141.61 159.534 207.077 198.021L276.965 0H350.796L487.384 387H410.918L384.102 309.128C339.565 329.296 288.194 329.303 243.652 309.148L216.846 387ZM266.356 243.205C270.767 245.539 275.309 247.525 279.946 249.165C301.851 256.908 325.862 256.908 347.767 249.165C352.418 247.52 356.975 245.527 361.398 243.184L313.882 104.967L266.356 243.205Z",
    fill: "#151826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnydayIcon);
export default __webpack_public_path__ + "static/media/anyday-icon.a092183cb7fd32ced43a0c6b4ea5031a.svg";
export { ForwardRef as ReactComponent };